import SearchableDropdown from 'shared/components/searchable_dropdown/SearchableDropdown';

export default SearchableDropdown;
